import React from 'react';
import { PermissionList, RolePermission } from 'utils';
import { distanceLabel } from './constants';

const initialsOf = (firstName, lastName, fallback) => {
    const a = (firstName || '').trim();
    const b = (lastName || '').trim();
    const initials = `${a ? a[0] : ''}${b ? b[0] : ''}`.toUpperCase();
    return initials || (fallback ? fallback.slice(0, 2).toUpperCase() : '?');
};

const plainNameOf = (person, fallback) =>
    [person?.firstName, person?.middleName ? `${person.middleName[0]}.` : '', person?.lastName]
        .filter(Boolean)
        .join(' ')
        .replace(/\s+/g, ' ')
        .trim() || fallback;

export const AssignedClientsModal = ({ staff, assignedClients = [], handleClose }) => {
    const staffName = plainNameOf(staff, 'Staff');
    const staffInitials = initialsOf(staff?.firstName, staff?.lastName);
    const badge = Array.isArray(staff?.tags) ? staff.tags[0] : null;
    const count = assignedClients.length;
    const canReadClient = RolePermission([PermissionList.CLIENT_READ?.code]);

    return (
        <div className="assigned-clients-modal" style={{  width: 600}}>
            <div className="assigned-clients-modal__header">
                <p className="modal-header-title">Assigned Clients</p>
            </div>

            <div className="assigned-clients-modal__staff">
                <div
                    style={{color: 'white', background:'#8658E9', width: 28, height: 28 }}
                    className="assigned-clients-modal__avatar assigned-clients-modal__avatar--staff">
                    {staff?.avatarUrl ? <img src={staff.avatarUrl} alt="" /> : <span>{staffInitials}</span>}
                </div>
                <p className="assigned-clients-modal__staff-name">{staffName}</p>
                {badge && <span className="assigned-clients-modal__badge">{badge}</span>}
                <span className="assigned-clients-modal__divider" />
                <p className="assigned-clients-modal__count">
                    {count} assigned client{count === 1 ? '' : 's'}
                </p>
            </div>

            <div className="assigned-clients-modal__list">
                {assignedClients.map((client) => {
                    const name = plainNameOf(client, client?.code || 'Client');
                    const distance = distanceLabel({ miles: client.distance, kind: client.distanceKind });
                    return (
                        <div key={client.id} className="assigned-clients-modal__row">
                            <div className="assigned-clients-modal__avatar">
                                {client?.avatarUrl ? (
                                    <img src={client.avatarUrl} alt="" />
                                ) : (
                                    <span>{initialsOf(client?.firstName, client?.lastName, client?.code)}</span>
                                )}
                            </div>
                            <div className="assigned-clients-modal__info">
                                <div className="assigned-clients-modal__name-row">
                                    {canReadClient ? (
                                        <a
                                            className="assigned-clients-modal__name"
                                            href={`/client/${client.id}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            {name}
                                        </a>
                                    ) : (
                                        <span className="assigned-clients-modal__name assigned-clients-modal__name--plain">{name}</span>
                                    )}
                                    {distance && (
                                        <span className="assigned-clients-modal__distance" title={distance.title}>
                                            {distance.text}
                                        </span>
                                    )}
                                </div>
                                {client.formattedAddress && (
                                    <p className="assigned-clients-modal__address">{client.formattedAddress}</p>
                                )}
                            </div>
                        </div>
                    );
                })}

                {count === 0 && <p className="assigned-clients-modal__empty">No assigned clients with a mappable address.</p>}
            </div>
        </div>
    );
};
